export default [
    {
		path: '/tag',
		name: 'Tag',
		component: () => import('@/views/tag/TagList.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'tags']]
		}
	},
    {
        path: '/tag/:id',
        name: 'Tag View',
        component: () => import('@/views/tag/TagMembers.vue'),
        meta:{
            layout: 'Default',
            abilities: [['manage', 'tags']]
            }
    }
]
